(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const toggleMenu = () => {
    const drawer = qs('[data-zv-drawer]');
    const toggle = qs('[data-zv-menu-toggle]');
    if (!drawer || !toggle) return;
    const open = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-zv-menu-toggle]');
    if (toggle) {
      event.preventDefault();
      toggleMenu();
    }
  });

  qsa('[data-zv-slideshow]').forEach((root) => {
    const slides = qsa('[data-zv-slide]', root);
    const dots = qsa('[data-zv-dot]', root);
    if (slides.length < 2) return;
    let index = 0;
    let timer;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => show(index + 1), 5200);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  qsa('[data-zv-qty]').forEach((wrap) => {
    const input = qs('input', wrap);
    wrap.addEventListener('click', (event) => {
      const btn = event.target.closest('button');
      if (!btn || !input) return;
      const next = Math.max(1, (Number(input.value) || 1) + Number(btn.dataset.delta || 0));
      input.value = String(next);
    });
  });

  qsa('[data-zv-gallery]').forEach((gallery) => {
    const main = qs('[data-zv-gallery-main]', gallery);
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-src]');
      if (!thumb || !main) return;
      main.src = thumb.dataset.src;
      qsa('.zv-pdp__thumbs button', gallery).forEach((btn) => {
        btn.classList.toggle('is-active', btn === thumb);
      });
    });
  });

  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return String(format || '{{amount}} SAR').replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  const bindVariantSelectors = () => {
    qsa('[data-zv-product-form]').forEach((form) => {
      const raw = form.querySelector('[data-zv-variant-data]');
      if (!raw) return;
      let variants = [];
      try {
        variants = JSON.parse(raw.textContent || '[]');
      } catch (error) {
        return;
      }

      const apply = () => {
        const selected = qsa('select[name^="options"]', form).map((input) => input.value);
        const variant = variants.find((item) =>
          selected.every((value, index) => String(item[`option${index + 1}`] || '') === String(value))
        ) || variants[0];
        if (!variant) return;

        const idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = String(variant.id);
        form.dataset.available = variant.available ? 'true' : 'false';

        const price = formatMoney(variant.price, form.dataset.moneyFormat);
        qsa('[data-zv-now-price], [data-zv-sticky-price]').forEach((node) => {
          node.textContent = price;
        });

        const add = form.querySelector('[name="add"]');
        const buy = form.querySelector('[name="checkout"]');
        const soldOut = add?.dataset.soldOut || 'Sold out';
        [add, buy].forEach((button) => {
          if (!button) return;
          button.disabled = !variant.available;
          if (!variant.available) {
            button.textContent = soldOut;
            button.setAttribute('data-zv-i18n', 'product.sold_out');
          }
        });
      };

      form.addEventListener('change', (event) => {
        if (event.target.closest('select[name^="options"]')) apply();
      });
    });
  };

  bindVariantSelectors();

  const openCart = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return;
    }
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
  };

  const addToCart = async (id, quantity) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message = payload.description || payload.message || 'add_failed';
      const error = new Error(message);
      error.soldOut = /sold out|نفد/i.test(String(message));
      throw error;
    }
    return payload;
  };

  const markSoldOut = (form, message) => {
    form.dataset.available = 'false';
    const soldOut = message || 'Sold out';
    qsa('[name="add"], [name="checkout"], [data-zv-sticky-add], [data-zv-qty] button, [data-zv-qty] input')
      .forEach((el) => {
        el.disabled = true;
        if (el.matches('[name="add"], [name="checkout"], [data-zv-sticky-add]')) {
          el.textContent = soldOut;
          if (el.hasAttribute('data-zv-i18n')) el.setAttribute('data-zv-i18n', 'product.sold_out');
        }
      });
    const status = form.querySelector('[data-zv-form-status]');
    if (status) {
      status.hidden = false;
      status.textContent = message || soldOut;
    }
  };

  const setBusy = (button, label) => {
    if (!button) return;
    button.disabled = true;
    button.textContent = label;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-zv-product-form]');
    if (!form) return;

    const soldOutLabel = form.querySelector('[name="add"]')?.dataset.soldOut || 'Sold out';
    if (form.dataset.available === 'false') {
      event.preventDefault();
      markSoldOut(form, soldOutLabel);
      return;
    }

    if (event.submitter && event.submitter.getAttribute('name') === 'checkout') return;

    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]')?.value || 0);
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const button = event.submitter || form.querySelector('[name="add"]');
    if (!id) return;

    const original = button ? button.textContent : '';
    setBusy(button, button?.dataset.adding || 'Adding...');

    try {
      await addToCart(id, quantity);
      if (button) button.textContent = button.dataset.added || 'Added';
      openCart();
      if (button) {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1400);
      }
    } catch (error) {
      if (error.soldOut) {
        markSoldOut(form, soldOutLabel);
        return;
      }
      if (button) button.textContent = button.dataset.error || 'Try again';
      if (button) {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1400);
      }
    }
  });

  document.addEventListener('click', (event) => {
    const sticky = event.target.closest('[data-zv-sticky-add]');
    if (!sticky || sticky.disabled) return;
    const form = qs('[data-zv-product-form]');
    if (!form || form.dataset.available === 'false') return;
    const add = form.querySelector('[name="add"]');
    if (add && !add.disabled) add.click();
  });

  const popup = qs('[data-zv-popup]');
  if (popup) {
    const posted = Boolean(popup.querySelector('.zv-form__success'));
    const seen = window.localStorage.getItem('zv-popup-seen') === '1';
    const close = () => {
      popup.hidden = true;
      window.localStorage.setItem('zv-popup-seen', '1');
    };
    popup.addEventListener('click', (event) => {
      if (event.target === popup || event.target.closest('[data-zv-popup-close]')) close();
    });
    if (posted) {
      popup.hidden = false;
      window.localStorage.setItem('zv-popup-seen', '1');
    } else if (!seen) {
      window.setTimeout(() => {
        popup.hidden = false;
      }, 7000);
    }
  }
})();
